import { NgModule } from '@angular/core';

import { Section07Component } from './section07.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        Section07Component
    ],
    imports: [
        TranslateModule,
        CommonModule
    ],
    exports: [
        Section07Component
    ]
})

export class Section07Module { }
